import React from "react";
import { useLocation } from "react-router";

import FleetConfiguration from "app/modules/FleetConfiguration";

import { getFleetParameters } from "../config/cddaFleetParameters";

const CddaFleetConfigurationComponent = () => {
    const location = useLocation();
    const componentContext = location.state?.componentContext ?? null;

    const parameters = getFleetParameters(componentContext);

    return <FleetConfiguration parameters={parameters} />;
};

export default CddaFleetConfigurationComponent;
